import Main from './new/Main.vue'
import init from '../root_init'

init(Main)